import url_acc from '@/urls/accounts'
import { sendPostRequest, sendPutRequest, sendDeleteRequest } from '@/helper/requests'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  createUserPhone: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Создает телефон пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - данные телефона для создания
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.PHONE.CREATE()
    sendPostRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  updateUserPhone: ({ commit }, { data, id, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Обновляет телефон пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - обновленные данные телефона
     * @param {string|number} id - идентификатор телефона
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.PHONE.UPDATE(id)
    sendPutRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  deleteUserPhone: ({ commit }, { id, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Удаляет телефон пользователя
     * @param {Object} commit - контекст Vuex
     * @param {string|number} id - идентификатор телефона
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.PHONE.DELETE(id)
    sendDeleteRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
